import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import moment from 'moment';

import './styles.scss';

const muiTheme = getMuiTheme({
  datePicker: {
    selectColor: '#004272',
    headerColor: '#004272'
  },
  flatButton: {
    textColor: '#004272',
    primaryTextColor: '#004272',
    secondaryTextColor: '#004272'
  }
});

const minDateGenerate = () =>
  // date.setDate(date.getDate() + 1);

  new Date(moment().add(1, 'day'));
const DatePickerComponent = ({
  controlledDate, handleChange, reference, pickUpDate, onFocusInput, setDateManualyHand,
  prevDisabled
}) => (
  <div className="date-picker">
    <div className="date-wrapper">
      <button
        className={`date-button -prev ${prevDisabled ? '-disabled' : ''}`}
        onClick={setDateManualyHand(-1)}
      >
        <i className="material-icons">arrow_back</i>
      </button>
      <button
        onClick={onFocusInput}
        className="date-input"
      >
        {pickUpDate}
      </button>
      <button
        className="date-button -next"
        onClick={setDateManualyHand(1)}
      >
        <i className="material-icons">arrow_forward</i>
      </button>
    </div>
    <div className="hidden">
      <MuiThemeProvider muiTheme={muiTheme}>
        <DatePicker
          hintText="Controlled Date Input"
          value={controlledDate}
          disableYearSelection
          onChange={handleChange}
          ref={reference}
          minDate={minDateGenerate()}
        />
      </MuiThemeProvider>
    </div>
  </div>
);


DatePickerComponent.propTypes = {
  controlledDate: PropTypes.instanceOf(Date).isRequired,
  handleChange: PropTypes.func.isRequired,
  reference: PropTypes.func.isRequired,
  pickUpDate: PropTypes.string.isRequired,
  onFocusInput: PropTypes.func.isRequired,
  prevDisabled: PropTypes.bool.isRequired,
  setDateManualyHand: PropTypes.func.isRequired
};

export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js